module.exports = __webpack_public_path__ + "static/media/loader.a31574ca.gif";